import React, { useState } from 'react'
import AnimateHeight from 'react-animate-height'
import { Link } from 'react-router-dom'
import { IconBottom } from 'shared/components'

import classes from './Info.module.scss'

type LinkType = {
  href: string
  text: string
  isNav?: boolean
}

const links1: LinkType[] = [
  // {
  //   href: require('assets/docs/Кодекс делового поведения и этики ООО КИОН.pdf'),
  //   text: 'Кодекс делового поведения и этики ООО КИОН',
  // },
  // {
  //   href: require('assets/docs/Кодекс делового поведения Контрагента ООО КИОН.pdf'),
  //   text: 'Кодекс делового поведения Контрагента ООО КИОН',
  // },
  // {
  //   href: require('assets/docs/Комментарии.docx'),
  //   text: 'Комментарии',
  // },
]

const links2: LinkType[] = [
  // {
  //   href: require('assets/docs/Политика по Соблюдению антикоррупционного законодательства ООО КИОН.pdf'),
  //   text: 'Приложение 1. Кодекс делового поведения контрагента  ООО КИОН',
  // },
  // {
  //   href: require('assets/docs/Политика по Управлению конфликтом интересов ООО КИОН.pdf'),
  //   text: 'Политика по Управлению конфликтом интересов ООО КИОН',
  // },
  // {
  //   href: require('assets/docs/Способы урегулирования типовых ситуаций конфликтов интереса.pdf'),
  //   text: 'Способы урегулирования типовых ситуаций конфликтов интереса',
  // },
  // {
  //   href: '/compliance/memo',
  //   text: 'Памятка к Кодексу делового поведения и этики',
  //   isNav: true,
  // },
]

export const Info: React.FC = () => {
  const [isTextOpen, setTextOpen] = useState(false)

  const renderLinks = (links: LinkType[]) => {
    const linkClasses = `link color ${classes['list__item-link']}`

    return (
      <ul className={classes.list}>
        {links.map((link, i) => (
          <li key={i} className={classes.list__item}>
            {!link.isNav ? (
              <a
                className={linkClasses}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                download={link.text}
              >
                {link.text}
              </a>
            ) : (
              <Link className={`${linkClasses} ${classes.file}`} to={link.href}>
                {link.text}
              </Link>
            )}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <div
      className={`row ${classes.row} reveal-from-bottom-medium`}
      data-reveal-delay={15}
    >
      <div
        className={`col-sm-6 col-xs-12 ${classes.col__desc} ${classes.order_1}`}
      >
        <h2 className={classes.title}>
          Кодекс делового <br /> поведения и этики
        </h2>
        <div className={classes.text}>
          <p>
            Это основополагающий документ, в котором изложены нормы
            внутрикорпоративного поведения, правила взаимодействия сотрудников
            KION с клиентами, деловыми партнерами, государственными органами и
            органами и внешними аудиториями. Кодекс обязателен для исполнения
            всеми сотрудниками KION вне зависимости от занимаемой должности.
          </p>
        </div>
      </div>

      <div
        className={`col-sm-6 col-xs-12 ${classes.col__desc} ${classes.order_3}`}
      >
        <h2 className={classes.title}>
          Соблюдение антикоррупционного <br /> законодательства
        </h2>
        <div className={classes.text}>
          <p>
            Для обеспечения соответствия деятельности KION требованиям
            применимого антикоррупционного законодательства, выявления, оценки,
            анализа и минимизации коррупционных рисков в Компании выстраивается
            система комплаенс.
          </p>
          <AnimateHeight
            className={classes.quote__text}
            height={isTextOpen ? 'auto' : 0}
          >
            <p>
              Утверждена Политика по соблюдению антикоррупционного
              законодательства и Политика по управлению конфликтом интересов, в
              соответствии с которыми должен действовать каждый сотрудник KION.
            </p>
          </AnimateHeight>
          <IconBottom
            className={classes.text__expand}
            onClick={() => setTextOpen(!isTextOpen)}
            isOpen={isTextOpen}
            openText={<small className="link color">Развернуть</small>}
            closeText={<small className="link color">Свернуть</small>}
          />
        </div>
      </div>

      <div className={`col-sm-6 col-xs-12 ${classes.order_2}`}>
        {renderLinks(links1)}
      </div>

      <div className={`col-sm-6 col-xs-12 ${classes.order_4}`}>
        {renderLinks(links2)}
      </div>
    </div>
  )
}
